/**
 * Role parsing and validation utilities for developer role emulation.
 *
 * Role format: Roles are stored as a concatenated string like "f1ff2ff3f"
 * where each role is surrounded by 'f' characters (e.g., "f1f", "f2f", "f3f").
 */

/**
 * Parse a role string into an array of individual roles.
 * @param {string} roleString - e.g., "f1ff2ff3f"
 * @returns {string[]} - e.g., ["f1f", "f2f", "f3f"]
 */
export const parseRoles = (roleString) => {
  if (!roleString || typeof roleString !== 'string') {
    return [];
  }
  const matches = roleString.match(/f\d+f/g);
  return matches || [];
};

/**
 * Build a role string from an array of roles.
 * @param {string[]} rolesArray - e.g., ["f1f", "f2f", "f3f"]
 * @returns {string} - e.g., "f1ff2ff3f"
 */
export const buildRoleString = (rolesArray) => {
  if (!Array.isArray(rolesArray) || rolesArray.length === 0) {
    return '';
  }
  return rolesArray.join('');
};

/**
 * Check if a set of roles is a valid subset of another set.
 * @param {string[]} subset - Roles to check
 * @param {string[]} superset - Roles to check against
 * @returns {boolean}
 */
export const isSubsetOf = (subset, superset) => {
  if (!Array.isArray(subset) || !Array.isArray(superset)) {
    return false;
  }
  return subset.every((role) => superset.includes(role));
};
